import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import { Link as RouterLink } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

const administrationSections = [
  {
    title: "Users",
    description: "Manage your user access",
    to: "/administration/users",
  },
  {
    title: "Facilities",
    description: "Manage labels for inputs and systems",
    to: "/administration/facilities",
  },
  {
    title: "Costs",
    description: "Capture your production inputs costs",
    to: "/administration/costs",
  },
  {
    title: "Billing",
    description: "See what you are paying for",
  },
];

function Administration() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MDBox px={1}>
              <MDTypography variant="h4" fontWeight="medium">
                Administration
              </MDTypography>
            </MDBox>
          </Grid>
          {administrationSections.map(({ title, description, to }) => (
            <Grid item xs={12} md={6} xl={3} key={title}>
              <Card sx={{ height: "100%", position: "relative" }}>
                <MDBox p={3} minHeight="150px">
                  <MDTypography variant="h5" fontWeight="medium">
                    {title}
                  </MDTypography>
                  <MDTypography variant="body2" color="text" mt={1}>
                    {description}
                  </MDTypography>
                  <MDBox
                    component={to ? RouterLink : "span"}
                    to={to}
                    aria-label={to ? `Open ${title}` : undefined}
                    position="absolute"
                    right="24px"
                    bottom="20px"
                    color="text"
                    lineHeight={1}
                    sx={{ textDecoration: "none" }}
                  >
                    <Icon fontSize="medium">manage_accounts</Icon>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          ))}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Administration;
